import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SAMU, useChartsData } from '../../../../Common/hooks/useChartsData';


export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children , module }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SAMU.GENERAL_RESULTS,
            url: 'governanceroom/dashboardsamu/results/general-results'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value
        }
    );

    const chartData = data
        ? {
              indicators: {
                  medicalRegulation:
                      data?.indicators?.medicalRegulation ?? 0,
                  withoutMedicalRegulation:
                      data?.indicators?.withoutMedicalRegulation ?? 0,
                  noLocation: data?.indicators?.noLocation ?? 0
              },
              medicalRegIndex: data?.medicalRegIndex ?? [],
              totalOcurrences: data?.totalOcurrences ?? 0,
              locationIndex: data?.locationIndex ?? [],
              specialCaresData: data?.specialCaresData ?? {},
              ocurrenceByForwarding: data?.ocurrenceByForwarding ?? [],
              annualOcurrencesEvolution:
                  data?.annualOcurrencesEvolution ?? [],
              ocurrencesByCallLocation:
                  data?.ocurrencesByCallLocation ?? [],
              totalLocationIdentified:
                  data?.totalLocationIdentified ?? [],
              totalEncountersPercentage:
                  data?.totalEncountersPercentage ?? []
          }
        : {
              indicators: {
                  medicalRegulation: 0,
                  withoutMedicalRegulation: 0,
                  noLocation: 0
                },
              medicalRegIndex: [],
              locationIndex: [],
              totalOcurrences: 0,
              annualOcurrencesEvolution: [],
              ocurrencesByCallLocation: [],
              ocurrenceByForwarding: [],
              totalLocationIdentified: [],
              totalEncountersPercentage: [],
              specialCaresData: {}
          };

    const colors = ['#1F77B4', '#FF7F0E'];

    const subtitles = ["teste 1", "teste 2"];

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                colors,
                subtitles,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
